var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveSubAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3439 7.375C18.2065 9.28141 16.7923 10.75 15.2501 10.75C13.7079 10.75 12.2914 9.28188 12.1564 7.375C12.0157 5.39172 13.3925 4 15.2501 4C17.1078 4 18.4845 5.42781 18.3439 7.375Z",
    fill: "#5D6679",
    stroke: "#5D6679",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2498 13.75C12.195 13.75 9.25731 15.2673 8.52138 18.2223C8.42388 18.6133 8.66903 19 9.07075 19H21.4293C21.8311 19 22.0748 18.6133 21.9787 18.2223C21.2428 15.22 18.3051 13.75 15.2498 13.75Z",
    fill: "#5D6679",
    stroke: "#5D6679",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87496 8.21594C8.76527 9.73844 7.62246 10.9375 6.39058 10.9375C5.15871 10.9375 4.01402 9.73891 3.90621 8.21594C3.79418 6.63203 4.90652 5.5 6.39058 5.5C7.87465 5.5 8.98699 6.66109 8.87496 8.21594Z",
    fill: "#5D6679",
    stroke: "#5D6679",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15671 13.8438C8.31062 13.4562 7.37874 13.3071 6.39108 13.3071C3.95358 13.3071 1.60515 14.5188 1.01686 16.879C0.939521 17.1912 1.13546 17.5001 1.45608 17.5001H6.71921",
    fill: "#5D6679"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15671 13.8438C8.31062 13.4562 7.37874 13.3071 6.39108 13.3071C3.95358 13.3071 1.60515 14.5188 1.01686 16.879C0.939521 17.1912 1.13546 17.5001 1.45608 17.5001H6.71921L7.5 17.5L10 14.5L9.15671 13.8438Z",
    fill: "#5D6679"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15671 13.8438C8.31062 13.4562 7.37874 13.3071 6.39108 13.3071C3.95358 13.3071 1.60515 14.5188 1.01686 16.879C0.939521 17.1912 1.13546 17.5001 1.45608 17.5001H6.71921L7.5 17.5L10 14.5L9.15671 13.8438Z",
    stroke: "#5D6679",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSubAdmin);
export default __webpack_public_path__ + "static/media/ActiveSubAdmin.c82ba40ffb0da308d7084b5ca912acc6.svg";
export { ForwardRef as ReactComponent };